const audiences = [
  {
    icon: "ri-user-star-line",
    title: "African Diaspora Professionals",
    desc: "Professionals living and working abroad who want structured guidance on building wealth across borders and connecting with African opportunity.",
    tag: "Diaspora",
  },
  {
    icon: "ri-home-heart-line",
    title: "Families & Family Offices",
    desc: "Families seeking to preserve and grow wealth across generations, with support for family office structure, governance, and long-term planning.",
    tag: "Family Wealth",
  },
  {
    icon: "ri-briefcase-4-line",
    title: "Entrepreneurs",
    desc: "Business owners and founders looking for strategic advisory, investor-readiness support, and cross-border growth pathways.",
    tag: "Entrepreneurs",
  },
  {
    icon: "ri-seedling-line",
    title: "Emerging Investors",
    desc: "Individuals at the beginning of their investment journey who want a credible, structured platform to build knowledge and confidence.",
    tag: "Emerging Investors",
  },
  {
    icon: "ri-exchange-line",
    title: "Investors Seeking Diversification",
    desc: "Experienced investors looking to diversify into African markets, private credit, or co-investment opportunities with trusted guidance.",
    tag: "Diversification",
  },
  {
    icon: "ri-links-line",
    title: "Strategic Partners",
    desc: "Development finance institutions, community organizations, and collaborators aligned with Harambee's mission of diaspora-centered wealth creation.",
    tag: "Partners",
  },
];

export default function WhoAdvisoryIsFor() {
  return (
    <section className="py-24 px-6 bg-[#F8F6F3]">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-flex items-center gap-2 text-[#C9A961] text-xs font-semibold uppercase tracking-[0.25em] mb-5">
            <span className="w-8 h-px bg-[#C9A961]" />
            Who We Serve
            <span className="w-8 h-px bg-[#C9A961]" />
          </span>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-[#2B2D2F] leading-tight mb-5">
            Advisory Services Designed for You
          </h2>
          <p className="text-[#6B6B6B] text-base leading-relaxed">
            Our advisory platform is built for a diverse range of clients united by a common goal &mdash; building lasting, intergenerational wealth with clarity and purpose.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {audiences.map((item) => (
            <div
              key={item.title}
              className="bg-white rounded-lg p-8 border border-[#E8E4DC] hover:border-[#C9A961]/40 transition-all duration-300 group"
            >
              <div className="flex items-start justify-between mb-5">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A4D3C]/10 group-hover:bg-[#1A4D3C]/20 transition-colors">
                  <i className={`${item.icon} text-[#1A4D3C] text-xl`} />
                </div>
                <span className="text-[10px] font-semibold uppercase tracking-wider text-[#C9A961] bg-[#C9A961]/10 px-3 py-1 rounded-full">
                  {item.tag}
                </span>
              </div>
              <h3 className="font-['Cormorant_Garamond'] text-xl font-bold text-[#2B2D2F] mb-3 leading-snug">
                {item.title}
              </h3>
              <p className="text-[#6B6B6B] text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
